import {ordersServicesPath
} from "../../Constants";
import axios from "axios";

const restUrl = ordersServicesPath + '/organizations/margin-type-orders'

export default class MarginTypeOrderController {
    static async getAll(materialOrganizationOptionId) {
        return axios.get(restUrl + "/by-material-organization-option?materialOrganizationOptionId=" + materialOrganizationOptionId);
    }

    static async update(data, id) {
        return await axios.put(restUrl + "/" + id,
            JSON.stringify({margin: data.margin, current: data.current}), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async delete(id) {
        await axios.delete(restUrl + '/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async create(data, materialOrganizationOptionId) {
        return await axios.post(restUrl + "?materialOrganizationOptionId=" + materialOrganizationOptionId + "&orderType=" + data.orderType,
            JSON.stringify({margin: data.margin, current: data.current}), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async byIds(data, ids) {
        const idsQuery = ids.reduce((acc, el) => (`${acc}&ids=${el}`), "")
        return await axios.post(restUrl + "/by-ids?orderType=" + data.orderType + idsQuery,
            JSON.stringify({margin: data.margin, current: data.current}), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }
}